import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimplePriceInfoModule } from '../simple-price-info/simple-price-info.module';
import { OfferCreditBannerComponent } from './offer-credit-banner.component';

@NgModule({
  declarations: [OfferCreditBannerComponent],
  imports: [CommonModule, SimplePriceInfoModule],
  exports: [OfferCreditBannerComponent]
})
export class OfferCreditBannerModule {}
